import styles from "../shPaymentProductModal.module.scss";
import React from "react";

const ShCheckoutHeaderItem = ( {
                                   className = "",
                                   children,
                                   isActive = false,
                                   isDone = false,
                                   onClick = () => { }
                               } ) => {
    return <li className={"small-text " + (isActive ? styles.active : "") + " " + (isDone ? styles.done : "") + " " + className}
               onClick={onClick}>
        { children }
    </li>
};

export default ShCheckoutHeaderItem;
